export default {
  contracts: {
    activeContracts: 'Kontrak Aktif',
    productsAndHours: 'Produk dan Waktu yang dilayani',
    supported: 'Didukung',
    notSupported: 'Tidak didukung',
    contact: 'Manajer'
  },
  states: {
    OPEN: 'Buka',
    AWAITING_REPLY: 'Menunggu Jawaban',
    CLOSED: 'Tutup',
    FEEDBACK_REQUIRED: 'Jawaban yang dibutuhkan',
    onlyRequired: 'Tindakan yang diperlukan',
    onlyWorkRequests: 'Tampilkan hanya Persetujuan Permintaan Pekerjaan'
  },
  common: {
    New: 'Baru',
    Open: 'Buka',
    Pending: 'Tunda',
    Closed: 'Tutup',
    create: 'Buat Baru',
    cancel: 'Batal',
    goBack: 'Kembali',
    close: 'Tutup',
    goToMain: 'Ke Halaman Utama'
  },
  property: {
    name: 'Properti',
    allProperties: 'Semua Properti',
    selectProperty: 'Pilih properti'
  },
  product: {
    name: 'Produk',
    allProducts: 'Semua produk',
    selectProduct: 'Pilih produk',
    goBack: 'Kembali',
    noProducts: 'Tidak ada produk'
  },
  chart: {
    chooseMonth: 'Pilih Bulan',
    noData: 'Tidak ada data untuk periode sekarang'
  },
  navigation: {
    main: 'Utama',
    interactions: 'Tiket',
    contracts: 'Kontrak',
    signOut: 'Keluar'
  },
  tickets: {
    createNewTitle: 'Buat Tiket Baru',
    title: 'Judul',
    noTickets: 'Tidak ada data dengan pencarian yang sekarang',
    search: 'Mencari',
    createNew: 'Buat Baru',
    reopenOrDisagree: 'Tidak Setuju',
    escalation: 'Eskalasi',
    reason: 'Alasan',
    reopen: 'Tidak Setuju',
    escalate: 'Eskalasi',
    opinionTitle: 'Komen anda sangat penting bagi kami!',
    opinionBody: 'Tolong berikan penilaian terhadap karyawan support kami',
    time: 'Resolusi Waktu',
    qualification: 'Kualifikasi Tehnik',
    communication: 'Komunikasi',
    sendFeedback: 'Kirim Komen',
    leaveFeedback: 'Tinggalkan Komen',
    close: 'Tutup',
    alreadyHasFeedback: 'Tiket sudah mempunyai komen',
    feedbackHasBeenSent: 'Komen sudah dikirim',
    ticketHasBeenReopened: 'Tiket sudah dibuka kembali ',
    ticketHasBeenEscalated: 'Tiket sudah di eskalasi',
    comment: 'Komen',
    keyPlaceholder: 'Ketik pesan',
    approve: 'Menyetujui',
    reject: 'Menolak',
    workRequestOnContractNotification:
      '{{fullName}} yang terhormat,\n\nSaat ini, Anda memiliki layanan bernilai tambah selama {{hoursInSupportContract}} jam yang disertakan dalam kontrak dukungan Anda.\nTiket {{workRequestId}} memerlukan waktu {{hoursRequested}} jam untuk diselesaikan. \n\nHarap setujui pengurangan jam dari saldo untuk tugas di atas.\nTerima kasih\n\nSalam,\n{{penulis}}',
    workRequestChargeableNotification:
      '{{fullName}} yang terhormat,\n\nPekerjaan ini tidak termasuk dalam layanan atau dijamin berdasarkan kontrak. Kami akan dengan senang hati menjadwalkan dan membantu. Kami memperkirakan {{hoursRequested}} jam untuk menyelesaikan permintaan {{workRequestId}}.\n\nBiaya untuk menyelesaikan permintaan ini adalah {{amount}}.\nPenawaran ini berlaku dalam waktu 7 hari sejak tanggal penerbitan. \nJika waktu sebenarnya yang dihabiskan melebihi penawaran awal, maka formulir permintaan tambahan untuk jam tambahan akan dikirimkan kepada pemohon untuk disetujui. Jika perkiraan waktu kurang dari penawaran awal, penawaran awal akan dibatalkan dan penawaran yang direvisi akan dikirimkan.\n\nHarap setujui pekerjaan tambahan dan biayanya.\n\nSalam,\n{{penulis}}',
    workRequestCommentRequired:
      'Harap berikan alasan untuk menolak permintaan pekerjaan.'
  },
  severity: {
    name: 'Prioritas',
    0: 'Normal',
    1: 'Penting',
    2: 'Penting sekali'
  },
  forms: {
    password: 'Password',
    confirmPassword: 'Konfirm password',
    passwordsDoNotMatch: 'Passwords tidak sesuai',
    updatePassword: 'Update password',
    askRestore: 'Password terbaru',
    remember: 'Ingat Password',
    restorePassword: 'Mengembalikan Password',
    signIn: 'Masuk'
  },
  transactions: {
    date: 'Tanggal',
    type: 'Tipe',
    comment: 'Komen',
    status: 'Status',
    subject: 'Pengerjaan yang diminta',
    name: 'Daftar Transaksi',
    hours: 'Waktu',
    viewTransactions: 'Melihat Transaksi',
    types: {
      WORK_REQUEST: 'Pengerjaan yang diminta',
      CONTRACT_ACTIVATION: 'Kontrak aktifasi',
      CONTRACT_EXPIRATION: 'Kontrak berakhir',
      MANUAL_ADJUST_ADD: 'Manual revisi-penambahan',
      MANUAL_ADJUST_DEDUCT: 'Manual revisi-pengurangan',
      TRANSFER_PROPERTY: 'Properti transfer',
      TRANSFER_PRODUCT: 'Produk transfer'
    }
  },
  transactionDetail: {
    name: 'Detail Transaksi',
    num: 'Nomor',
    insertTime: 'Tanggal dibuat',
    requestorName: 'Nama yang meminta',
    subject: 'Subjek',
    status: 'Status',
    acceptTime: 'Tanggal diterima',
    cancelTime: 'Tanggal Pembatalan',
    hours: 'Jam',
    hourType: 'Tipe',
    workText: 'Keterangan Pengerjaan',
    plannedDate: 'Tanggal yang direncanakan'
  },
  statuses: {
    Approved: 'Disetujui',
    Pending: 'Tunda',
    Cancelled: 'Batal'
  },
  hoursTypes: {
    'Termasuk di kontrak': 'Termasuk di kontrak',
    'Waktu Instalasi': 'Waktu Instalasi',
    'Kunjungan Pencegahan': 'Kunjungan Pencegahan',
    Chargeable: 'Dikenakan Biaya'
  },
  errors: {
    unknown: 'Unknown error',
    1000: 'Request error',
    1001: 'Request error',
    1: 'Incorrect login or password',
    2: 'Session expired',
    3: 'Unknown property',
    4: 'Unknown product',
    7: 'Unknown interaction',
    8: 'Interaction already closed',
    11: 'Access violation',
    12: 'Unknown workrequest'
  }
}
